export default {
  aiAssistant: {
    greeting: "Hello! I'm your AI assistant XiaoTu.",
  },
  messages: {
    sessionExpired: "Session expired, please log in again",
  },
};
